export const DateFormat = {
    "DD-MM-YYYY": "dd-MM-yyyy",
    "DD/MM/YYYY": "dd/MM/yyyy",
};
